<div>
    <div class="container">
      <div class="section-faq">
        <header class="mb-5">
          <h2 class="font-sm">{{ title}}</h2>
        </header>
        <div
          *ngFor="let item of faq; let key = index"
          class="accordion"
          id="accordionExample{{ key }}"
        >
          <div class="accordion-item">
            <h2 class="accordion-header" id="p{{ key }}">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                attr.data-bs-target="#c{{ key }}"
                aria-expanded="true"
                attr.aria-controls="c{{ key }}"
              >
                {{ item.ask }}
              </button>
            </h2>
            <div
              id="c{{ key }}"
              class="accordion-collapse collapse"
              attr.aria-labelledby="p{{ key }}"
              attr.data-bs-parent="#accordionExample{{ key }}"
            >
              <div class="accordion-body" [innerHtml]="item.res"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>